import PropTypes from 'prop-types';
import React, {memo} from 'react';

import {useSocialDenomination} from '@/modules/proposalRequest/hooks/useSocialDenominationType';

const ProposalSimilarItem = ({value}) => {
  const name = useSocialDenomination(value);
  return (<span>{name}</span>);
};

ProposalSimilarItem.propTypes = {
  value: PropTypes.object,
};

ProposalSimilarItem.defaultProps = {};

export default memo(ProposalSimilarItem);
